import { Routes, Route, Navigate } from 'react-router-dom'
import Home from './component/Home'
import SectionLayout from './component/layout/SectionLayout'
import SectionLanding from './component/layout/SectionLanding'
import CollectionCreateForm from './component/collections/CollectionCreateForm'
import CollectionUpdateForm from './component/collections/CollectionUpdateForm'
import CollectionAccountUpdateForm from './component/collections/CollectionAccountUpdateForm'
import UserForm from './component/UserForm'
import SimplePaymentForm from './component/SimplePaymentForm'
import FundingCreateForm from './component/funding/FundingCreateForm'
import FundingUpdateForm from './component/funding/FundingUpdateForm'
import DeductionCreateForm from './component/deduction/DeductionCreateForm'
import DeductionUpdateForm from './component/deduction/DeductionUpdateForm'
import { paths } from './routes'

const Main = () => {
    return (
        <Routes>
            <Route path={paths.home} element={<Home />} />
            <Route path={paths.collection.root} element={<SectionLayout section="collection" legacyUpdatePath={paths.collection.update} />}>
                <Route index element={<SectionLanding section="collection" />} />
                <Route path="create" element={<CollectionCreateForm />} />
                <Route path="update/:id?" element={<CollectionUpdateForm />} />
                <Route path="account/:accountNumber?" element={<CollectionAccountUpdateForm />} />
            </Route>
            <Route path={paths.user()} element={<SectionLayout section="user" />}>
                <Route path=":id?" element={<UserForm />} />
            </Route>
            <Route path={paths.simplePayment()} element={<SectionLayout section="simplePayment" />}>
                <Route path=":id?" element={<SimplePaymentForm />} />
            </Route>
            <Route path={paths.funding.root} element={<SectionLayout section="funding" legacyUpdatePath={paths.funding.update} />}>
                <Route index element={<SectionLanding section="funding" />} />
                <Route path="create" element={<FundingCreateForm />} />
                <Route path="update/:id?" element={<FundingUpdateForm />} />
            </Route>
            <Route path={paths.deduction.root} element={<SectionLayout section="deduction" legacyUpdatePath={paths.deduction.update} />}>
                <Route index element={<SectionLanding section="deduction" />} />
                <Route path="create" element={<DeductionCreateForm />} />
                <Route path="update/:id?" element={<DeductionUpdateForm />} />
            </Route>
            <Route path="*" element={<Navigate to={paths.home} replace />} />
        </Routes>
    )
}
export default Main
